import React from 'react';

const CustomScannerIcon = (props) => (
  <svg 
    viewBox="0 0 100 100" 
    xmlns="http://www.w3.org/2000/svg"
    height="1em"
    width="1em"
    {...props}
  >
    {/* Handle (Extended downwards) */}
    <rect x="40" y="50" width="20" height="46" rx="6" fill="currentColor" opacity="0.85"/>
    
    {/* Seam/Connection collar */}
    <path d="M 36 50 C 36 46 64 46 64 50" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
    
    {/* Outer Frame (Shifted up slightly) */}
    <rect 
      x="18" 
      y="10" 
      width="64" 
      height="42" 
      rx="15" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="6" 
      strokeLinejoin="round"
    />
    
    {/* Inner Screen */}
    <rect 
      x="23" 
      y="15" 
      width="54" 
      height="32" 
      rx="10" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2"
    />
    
    {/* Barcode Bars on Screen */}
    <rect x="30" y="20" width="3" height="22" rx="0.5" fill="currentColor"/>
    <rect x="36" y="20" width="5" height="22" rx="0.5" fill="currentColor"/>
    <rect x="44" y="20" width="2" height="22" rx="0.5" fill="currentColor"/>
    <rect x="49" y="20" width="6" height="22" rx="0.5" fill="currentColor"/>
    <rect x="58" y="20" width="2" height="22" rx="0.5" fill="currentColor"/>
    <rect x="63" y="20" width="4" height="22" rx="0.5" fill="currentColor"/>
    <rect x="69" y="20" width="2" height="22" rx="0.5" fill="currentColor"/>
  </svg>
);

export default CustomScannerIcon;
